import { urlWithQuery } from '~/utils/url';
import { BaseRestRepository } from './baseRestRepository';

const BILLS_URL = '/api/service-bills';

export class ServiceBillRepository extends BaseRestRepository {
  public async addServiceBill(data: MagicDoor.Api.AddServiceBillDto): Promise<MagicDoor.Api.ServiceBillResultDto> {
    const url = `${BILLS_URL}`;
    const response = await this.fetchWithAuth(url, { method: 'POST', body: JSON.stringify(data) });
    return await this.getJsonResponse(response);
  }

  public async getServiceBills(filters: MagicDoor.Filter): Promise<MagicDoor.Api.HydratedServiceBillPaginationDto> {
    const url = BILLS_URL;
    const response = await this.fetchWithAuth(urlWithQuery(url, filters));
    return this.getJsonResponse(response);
  }

  public async getServiceBill(billId: string): Promise<MagicDoor.Api.ServiceBillResultDto> {
    const url = `${BILLS_URL}/${billId}`;
    const response = await this.fetchWithAuth(url, { method: 'GET' });
    return this.getJsonResponse(response);
  }

  public async updateServiceBill(billId: string, data: MagicDoor.Api.UpdateServiceBillDto) {
    const url = `${BILLS_URL}/${billId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
    return this.getJsonResponse(response);
  }

  public async deleteServiceBill(billId: string) {
    const url = `${BILLS_URL}/${billId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
}
